import { useUser } from "@/store/user";
import type { RouteRecordRedirectOption } from "vue-router";

export const home = (): RouteRecordRedirectOption => {
  const userStore = useUser();
  
  if (userStore.hasSelectedAdministratorRole) {
    return { name: "administrator-dashboard" };
  }
  if (userStore.hasSelectedBackofficeUserRole) {
    return { name: "backofficeuser-dashboard" };
  }
  if (userStore.hasSelectedProfessionalRole) {
    return { name: "professional-dashboard" };
  }
  if( userStore.hasSelectedOwnerRole || userStore.hasSelectedTenantRole ){
    return { name: "reports" };
  }
  if (!userStore.isLoggedIn) {
    return {
      name: "welcome",
      query: { mode: "FinalUser" },
    };
  }

  return {
    name: "placeholder",
    query: { mode: "FinalUser" },
  };

  // return {
  //   name: 'placeholder',
  //   query: { mode: "FinalUser"}
  // }
};
